import { render, staticRenderFns } from "./MovementBulkUpdate.vue?vue&type=template&id=16e6624a&scoped=true&"
import script from "./MovementBulkUpdate.vue?vue&type=script&lang=js&"
export * from "./MovementBulkUpdate.vue?vue&type=script&lang=js&"
import style0 from "./MovementBulkUpdate.vue?vue&type=style&index=0&id=16e6624a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e6624a",
  null
  
)

export default component.exports